"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _toDay = _interopRequireDefault(require("./components/toDay"));

var _transaction = _interopRequireDefault(require("./components/transaction"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//
//
//
//
//
//
//
var _default = {
  name: "index",
  components: {
    toDay: _toDay.default,
    transactionFrom: _transaction.default
  }
};
exports.default = _default;